<template>
  <div class="wrapper">
    <!--  swiper  -->
    <div class="swiper-box">
      <!-- swiper -->
      <swiper :options="swiperOption">
        <swiper-slide class="swiper-slide slide-1">
          <a href="#">
            <img src="../assets/owl/o5.jpg" alt="">
          </a>
        </swiper-slide>
        <swiper-slide class="swiper-slide slide-2">
          <a href="/#/B941B" v-on:click="sendMsg(1, 0, 1)">
            <img src="../assets/owl/o1.jpg" alt="">
          </a>
        </swiper-slide>
        <swiper-slide class="swiper-slide slide-3">
          <a href="/#/D2000A" v-on:click="sendMsg(1, 1, 1)">
            <img src="../assets/owl/o2.jpg" alt="">
          </a>
        </swiper-slide>
        <swiper-slide class="swiper-slide slide-2">
          <a href="/#/D3000" v-on:click="sendMsg(1, 1, 2)">
            <img src="../assets/owl/o3.jpg" alt="">
          </a>
        </swiper-slide>
        <swiper-slide class="swiper-slide slide-3">
          <a href="/#/D1000" v-on:click="sendMsg(1, 1, 0)">
            <img src="../assets/owl/o4.jpg" alt="">
          </a>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination swiper-pagination-white"></div>
        <div slot="button-prev" class="swiper-button-prev swiper-button-white"></div>
        <div slot="button-next" class="swiper-button-next swiper-button-white"></div>
      </swiper>
    </div>
    <div style="background: #002752;margin-bottom: 20px;color: white;padding: 10px;font-weight: bold">
      云平台入口：欢迎来到博远电子。点击体验分布式在线监测。
      <Button @click="toLink" style="float: right;margin-top: -2px">立即体验</Button>
    </div>
    <!-- products-types start -->
    <div class="box">
      <div class="container">
        <div class="products-types">
          <div class="row">
            <div class="col-md-4 col-sm-6">
              <div class="slide-child-box">
                <img src="../assets/center/address/bridge.jpg" alt="">
                <div class="bottom-box">
                  <h5><a href="/#/bridge" class="product-name" v-on:click="sendMsg(2, 0, '')">桥梁振动监测</a></h5>
<!--                  <p class="product-reference">Model: M4HDLXWH</p>-->
                  <div class="btm">
                    <div class="button-box">
                      <Button type="primary">
                        <a href="/#/bridge" v-on:click="sendMsg(2, 0, '')">查看详情</a>
                      </Button>
                      <!--                      <a type="" href="#">查看详情</a>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="slide-child-box">
                <img src="../assets/center/address/dam.jpg" alt="">
                <div class="bottom-box">
                  <h5><a href="/#/dam"
                         class="product-name"
                         v-on:click="sendMsg(2, 1, '')">大坝振动监测</a></h5>
<!--                  <p class="product-reference">Model: M4HDLXWH</p>-->
                  <div class="btm">
                    <div class="button-box">
                      <Button type="primary">
                        <a href="/#/dam"
                           v-on:click="sendMsg(2, 1, '')"
                        >查看详情</a>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="slide-child-box">
                <img src="../assets/center/address/well.jpg" alt="">
                <div class="bottom-box">
                  <h5><a href="/#/pit" class="product-name"
                         v-on:click="sendMsg(2, 2, '')"
                  >井下振动监测</a></h5>
<!--                  <p class="product-reference">Model: M4HDLXWH</p>-->
                  <div class="btm">
                    <div class="button-box">
                      <Button type="primary">
                        <a href="/#/pit"
                           v-on:click="sendMsg(2, 2, '')"
                        >查看详情</a>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="slide-child-box">
                <img src="../assets/center/address/wind.jpg" alt="">
                <div class="bottom-box">
                  <h5><a href="/#/wind" class="product-name"
                         v-on:click="sendMsg(2, 4, '')"
                  >风电振动监测</a></h5>
<!--                  <p class="product-reference">Model: M4HDLXWH</p>-->
                  <div class="btm">
                    <div class="button-box">
                      <Button type="primary">
                        <a href="/#/wind"
                           v-on:click="sendMsg(2, 4, '')"
                        >查看详情</a>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="slide-child-box">
                <img src="../assets/center/address/high-level.jpg" alt="">
                <div class="bottom-box">
                  <h5><a href="/#/highRise" class="product-name"
                         v-on:click="sendMsg(2, 3, '')"
                  >高层结构振动监测</a></h5>
<!--                  <p class="product-reference">Model: M4HDLXWH</p>-->
                  <div class="btm">
                    <div class="button-box">
                      <Button type="primary">
                        <a href="/#/highRise"
                           v-on:click="sendMsg(2, 3, '')"
                        >查看详情</a>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="slide-child-box">
                <img src="../assets/center/address/precise.jpg" alt="">
                <div class="bottom-box">
                  <h5><a href="/#/precision" class="product-name"
                         v-on:click="sendMsg(2, 5, '')"
                  >特殊精密场所振动监测</a></h5>
<!--                  <p class="product-reference">Model: M4HDLXWH</p>-->
                  <div class="btm">
                    <div class="button-box">
                      <Button type="primary">
                        <a href="/#/precision"
                           v-on:click="sendMsg(2, 5, '')"
                        >查看详情</a>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- products-types end -->
  </div>
</template>

<script>
import {getContactDetail, getExampleType, getHomeDetail, getService, getHomeCarousel} from '../utils/api'
export default {
  name: 'index',
  // inject: ['reload'],
  props: {},
  data () {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          waitForTransition: true
        },
        spaceBetween: 0,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperListOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 4,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      productList: [
        {
          name: 'BATHROOM HEATERS'
        },
        {
          name: 'CEILING FANS'
        },
        {
          name: 'STRIP HEATERS'
        },
        {
          name: 'EXHAUST FANS'
        }
      ],
      personName: '',
      personEmail: '',
      personMeaasge: '',
      TextAlign: 'center',
      homeData: {},
      contactData: {},
      serverData: '',
      aboutContent: 'about-content-en',
      strengthBox: 'strength-box-en',
      ExampleData: [],
      carouselData: []
    }
  },
  computed: {
    showZh () {
      return this.$i18n.locale === 'zh'
    }
  },
  watch: {
    ExampleData: function () {}
  },
  mounted () {
    if (localStorage.getItem('Language') === 'zh') {
      this.aboutContent = 'about-content-zh'
      this.strengthBox = 'strength-box-zh'
    } else {
      this.aboutContent = 'about-content-en'
      this.strengthBox = 'strength-box-en'
    }
    this.getCarouselData()
    this.getHomeDetail()
    this.getContactDetail()
    this.getService()
  },
  methods: {
    toLink () {
      var p = window.location.protocol
      var a = document.createElement('a')
      a.setAttribute('href', `${p}//cloud.boyuandianzi.com`)
      a.setAttribute('target', '_blank')
      a.click()
    },
    async getCarouselData () {
      this.carouselData = await getHomeCarousel()
    },
    async getHomeDetail () {
      let getHomeData = await getHomeDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.homeData = {
          about_hantas: getHomeData.about_hantas_zh,
          choose_us: getHomeData.choose_us_zh,
          our_strength: getHomeData.our_strength_zh
        }
      } else {
        this.homeData = {
          about_hantas: getHomeData.about_hantas_en,
          choose_us: getHomeData.choose_us_en,
          our_strength: getHomeData.our_strength_en
        }
      }
    },
    async getContactDetail () {
      let getContactData = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: getContactData.address_zh,
          email: getContactData.email,
          phone: getContactData.phone,
          work_time: getContactData.work_time_zh
        }
      } else {
        this.contactData = {
          address: getContactData.address_en,
          email: getContactData.email,
          phone: getContactData.phone,
          work_time: getContactData.work_time_en
        }
      }
    },
    async getService () {
      this.serverData = []
      let getServerData = await getService()
      for (let i in getServerData) {
        let tempData = {
          content: '',
          id: getServerData[i].id,
          image: getServerData[i].image,
          is_active: getServerData[i].is_active
        }
        if (localStorage.getItem('Language') === 'zh') {
          tempData.content = getServerData[i].content_zh
        } else {
          tempData.content = getServerData[i].content_en
        }
        this.serverData.push(tempData)
      }
    },
    async routerTo (id, type) {
      let workData = await getExampleType({type: 1})
      let workIdData = []
      for (let i of workData) {
        workIdData.push(i.id)
      }
      if (workIdData.includes(type)) {
        window.sessionStorage.setItem('currentFirstIndex', 0)
        this.$router.push({ name: 'commercialDetail',
          query: {projectType: type, detailIndex: id}})
      } else {
        window.sessionStorage.setItem('currentFirstIndex', 1)
        this.$router.push({ name: 'residentialDetail',
          query: {projectType: type, detailIndex: id}})
      }
      this.$emit('headOne', 1)
      window.sessionStorage.setItem('currentFirstIndex', 1)
    },

    sendMsg (first, second, third) {
      let msg = {
        first: 'currentFirstIndex',
        firstIndex: first,
        second: 'currentSecondIndex',
        secondIndex: second,
        third: 'currentThirdIndex',
        thirdIndex: third
      }
      this.$emit('headCurrent', msg)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .aboutImg{
    width: 100%;
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 0;
    vertical-align: middle;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
  }

  .whyMe{
    width: 57%;
    margin: auto;
  }
  .about-content-zh >>> p{
    text-align: justify;
    font-size: 18px;
    display: block;
    font-weight: 400;
  }
  .about-content-en >>> p{
    text-align: justify;
    /*font-family: Roboto,sans-serif;*/
    font-size: 16px;
  }

  .strength-box-zh >>> li > * {
    color: #282828;
    list-style-type:disc;
    font-size: 18px;
  }
  .strength-box-zh >>> li  {
    list-style-type: disc !important;
    line-height: 22px;
    padding-bottom: 10px;
  }

  .strength-box-en >>> li > * {
    color: #282828;
    list-style-type:disc;
    /*font-family: 'Roboto', sans-serif;*/
    font-size: 18px;
  }
  .strength-box-en >>> li  {
    padding-bottom: 10px;
    line-height: 22px;
    list-style-type: disc !important;
  }

  .chooseUs >>> li:first-child{
    font-size: 18px;
    list-style-type: disc;
    line-height: 24px;
    color: #282828;
    font-weight: 400;
    padding-bottom: 10px;
  }
  .pGrey{
    color: #777;
    font-size: 32px;
    margin-top: 50px;
    line-height: 40px;
  }
  .centerDiv {
    width: 58%;
    top: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: flex-end;
  }

  .alignCenter{
    text-align: center;
    padding-left: 0;
    width: 45%;
    margin: auto;
  }

  .alignLeft{
    text-align: left;
    padding-left: 60px;
    list-style-type: disc!important;
  }

  .strengthImg {
    height: 260px;
  }

  @media screen and (max-width: 768px) {
    .strengthImg {
      display: none;
    }

    .centerDiv {
      width: 100%;
    }

    .alignLeft{
      padding-left: 0;
    }

    .alignLeft h2{
      text-align: center!important;
    }

    .whyMe{
      width: 100%;
    }

    .alignCenter{
      width: 100%;
    }
  }

  .pStyle {
    color: #282828;
    font-size: 16px;
    line-height: 22px;
    display: flex;
  }

  .dot{
    width: 15px;
  }

  .contentSpan{
    width: 100%;
  }

  .weight{
    font-weight: 600;
  }

  .pStyleBig {
    color: #282828;
    font-size: 16px;
    margin-top: 30px;
    font-weight: 600;
  }

  .pStyle2 {
    color: #282828;
    font-size: 15px;
    line-height: 24px;
    display: flex;
  }

  .pGrey {
    color: #777;
    font-size: 32px;
    margin-top: 50px;
    line-height: 40px;
  }

  .swiper-slide a{
    display: block;
  }
  .swiper-slide a img{
    width: 100%;
  }
</style>

<!-- products-types -->
<style scoped>
  .nav-tabs{
    border: none;
  }

  .nav-li-class a{
    font: 700 25px/26px "Roboto Condensed",sans-serif;
    text-transform: uppercase;
    padding: 5px 40px;
    padding-left: 0;
    margin: 0;
    border: none;
    color: #3d3d3d;
    background: transparent;
    position: relative;
    z-index: 1;
    opacity: 0.5;
  }

  .nav-tabs > li.active > a {
    background: transparent;
    color: #3d3d3d;
    border: none;
    opacity: 1;
  }

  .nav-tabs > li > a:hover, .nav-tabs > li > a:focus {
    background: transparent;
    opacity: 1;
  }

  .products-types{
    margin-bottom: 20px;
    margin-top: 15px;
  }

  .slide-child-box {
    overflow: hidden;
    position: relative;
    background-color: #ffffff;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-box-shadow: 0 1px 5px #c7c7c7;
    -webkit-box-shadow: 0 1px 5px #c7c7c7;
    box-shadow: 0 1px 5px #c7c7c7;
    width: 300px;
    display: inline-block;
  }

  .slide-child-box img{
    width: 100%;
  }

  .bottom-box h5{
    margin: 0;
    padding: 12px 5%;
    text-align: center;
    background: #f7f7f7;
  }

  .product-name{
    /*font-family: "Roboto",sans-serif;*/
    font-size: 13px;
    font-weight: bold;
    line-height: 16px;
    color: #3d3d3d;
    margin-bottom: 0;
  }

  .product-reference{
    text-align: center;
    background: #f7f7f7;
    padding-bottom: 8px;
  }

  .btm{
    display: table;
    width: 100%;
    padding: 12px 6%;
    min-height: 64px;
  }

  .button-box{
    text-align: right;
    display: table-cell;
    vertical-align: middle;
  }

  .button-box Button{
    background: #fecd32;
    color: #fff;
    border-color: #fecd32;
  }

  .button-box a{
    color: white;
  }
</style>

<!-- img-box -->
<style scoped>
  .img-box{
    width: 100%;
    height: auto;
    position: relative;
  }

  .img-box img{
    width: 100%;
    height: auto;
  }

  .img-box a{
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    font-size: 43px;
    margin-bottom: 20px;
    text-shadow: 1px 2px 1px rgba(0,0,0,0.5);
    color: white;
  }

  .img-box a:hover{
    color: #00a4e4;
    cursor: pointer;
  }

  @media (max-width: 800px){
    .img-box a {
      font-weight: bold;
      font-size: 25px;
    }
  }
</style>

<!-- img-fix -->
<style scoped>
  .img-fixed-block{
    box-sizing: border-box;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    position: relative;
    z-index: 1;
  }

  .block-img{
    background-image: url("../assets/fix.jpg");
    height: 500px;
    background-attachment: fixed;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    margin-bottom: 0px;
  }

  .block-img1{
    background-image: url("../assets/fix0.jpg");
    height: 500px;
    background-attachment: fixed;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    margin-bottom: 0px;
  }

  @media only screen and (max-device-width: 1024px){
    .block-img, .block-img1 {
      background-attachment: scroll;
    }
  }

</style>

<!-- word-block -->
<style scoped>
  .word-block{
    background: black;
    color: white;
    line-height: 30px;
    box-sizing: border-box;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    position: relative;
    z-index: 1;
    padding-top: 20px;
    padding-bottom: 20px;
    overflow: hidden;
  }

  .word-box{
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 400px;
    font-size: 35px;
    line-height: 40px;
    /*padding: 0;*/
  }

  .rte{
    background: transparent none repeat scroll 0 0;
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    font-size: 100%;
    vertical-align: baseline;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue